import React from 'react'
// import Chatbot from './ChatBot/chatbot'


const Home = () => {
  return (
    <div>Home
       <div>
      <h1>Welcome to My App</h1>
      {/* <Chatbot/> */}
      
    

      
    </div>
    </div>
  )
}

export default Home